export const FieldCategoryStatus = {
  PENDING: 'field-category-pending',
  ADDED: 'field-category-created',
  UPDATED: 'field-category-updated',
  FETCHED: 'field-category-fetched',
  ERROR: 'field-category-error',
};
